// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-xlg {
  font-size: 32px;
}

.font-lg {
  font-size: 22px;
}

.font-mdlg {
  font-size: 18px;
}

.font-md {
  font-size: 14px;
}

.font-sm {
  font-size: 12px;
}

.form-sm label.title {
  font-size: 1rem;
  margin: 0 0 11px 0;
  font-family: Inter;
}

.fw-600 {
  font-weight: 600;
}

.font-size-h4 {
  font-size: 23.5px;
}

.options {
  padding-left: 7px;
  padding-right: 7px;
}

button {
  background-color: transparent;
  border: none;
  color: #00709e;
}
button.circle {
  background-color: white;
  border: 1px solid #ccc;
}
button.transparent {
  background-color: transparent;
}

.options-button {
  border-radius: 50%;
  width: 38px;
  cursor: pointer;
}

.top-button {
  border-radius: 0.25rem;
  padding-left: 14px;
  padding-right: 14px;
}
.top-button img {
  padding-bottom: 2px;
}

.options-box {
  border: 1px solid grey;
  min-width: 235px;
  width: max-content;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.3);
  position: absolute;
  background-color: white;
  z-index: 100;
  right: 0;
}
.options-box.circle {
  top: 45px;
}

.topspacing {
  top: 35px;
}

.menu-disabled {
  opacity: 0.5;
  pointer-events: none;
  color: #ccc;
}
.menu-disabled button {
  color: #ccc;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/styles/sizes.scss","webpack://./src/app/components/context-menu/context-menu.component.scss"],"names":[],"mappings":"AAmBA;EACE,eAPS;ACXX;;ADqBA;EACE,eAVQ;ACRV;;ADqBA;EACE,eAbU;ACLZ;;ADqBA;EACE,eAhBQ;ACFV;;ADqBA;EACE,eAnBQ;ACCV;;ADsBE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;ACnBJ;;ADuBA;EACE,gBAAA;ACpBF;;ADuBA;EACE,iBAAA;ACpBF;;AA7BA;EACE,iBAAA;EACA,kBAAA;AAgCF;;AA7BA;EACE,6BAAA;EACA,YAAA;EACA,cAAA;AAgCF;AA9BE;EACE,uBAAA;EACA,sBAAA;AAgCJ;AA9BE;EACE,6BAAA;AAgCJ;;AA5BA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA+BF;;AA5BA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;AA+BF;AA7BE;EACE,mBAAA;AA+BJ;;AA3BA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,QAAA;AA8BF;AA7BE;EACE,SAAA;AA+BJ;;AA3BA;EACE,SAAA;AA8BF;;AA3BA;EACE,YAAA;EACA,oBAAA;EACA,WAAA;AA8BF;AA7BE;EACE,WAAA;AA+BJ;AACA,g+GAAg+G","sourcesContent":["$min-page-width: 1260px;\n$main-box-width: 1074px;\n$header-height: 80px;\n\n$main-form-circle-font-size: 0.875rem;\n$main-form-title-font-size: 1.125rem;\n$main-form-label-font-size: 1rem;\n\n$dialog-close-x: 22px;\n$dialog-header-title-main-font-size: 2rem;\n$dialog-header-title-font-size: 1.375rem;\n$dialog-header-title-font-size-small: 12px;\n\n$font-xlg: 32px;\n$font-lg: 22px;\n$font-mdlg: 18px;\n$font-md: 14px;\n$font-sm: 12px;\n\n.font-xlg {\n  font-size: $font-xlg;\n}\n\n.font-lg {\n  font-size: $font-lg;\n}\n\n.font-mdlg {\n  font-size: $font-mdlg;\n}\n\n.font-md {\n  font-size: $font-md;\n}\n\n.font-sm {\n  font-size: $font-sm;\n}\n\n.form-sm {\n  label.title {\n    font-size: 1rem;\n    margin: 0 0 11px 0;\n    font-family: Inter;\n  }\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.font-size-h4 {\n  font-size: 23.5px;\n}\n","@import 'sizes';\n@import 'colors';\n\n.options {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  color: #00709e;\n\n  &.circle {\n    background-color: white;\n    border: 1px solid #ccc;\n  }\n  &.transparent {\n    background-color: transparent;\n  }\n}\n\n.options-button {\n  border-radius: 50%;\n  width: 38px;\n  cursor: pointer;\n}\n\n.top-button {\n  border-radius: 0.25rem;\n  padding-left: 14px;\n  padding-right: 14px;\n\n  img {\n    padding-bottom: 2px;\n  }\n}\n\n.options-box {\n  border: 1px solid grey;\n  min-width: 235px;\n  width: max-content;\n  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.3);\n  position: absolute;\n  background-color: white;\n  z-index: 100;\n  right: 0;\n  &.circle {\n    top: 45px;\n  }\n}\n\n.topspacing {\n  top: 35px;\n}\n\n.menu-disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  color: #ccc;\n  button {\n    color: #ccc;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
